import {
  DialogContent,
  DialogContentProps,
  DialogOverlay,
} from '@reach/dialog';
import cx from 'classnames';
import * as React from 'react';
import { CloseIcon } from './icon/close-icon';
import { useLocalize } from './localize-context';

type DialogProps = {
  title: string;
  isOpen: boolean;
  onDismiss: () => void;
  compact?: boolean;
  children: React.ReactNode;
  fitContent?: boolean;
} & Omit<DialogContentProps, 'aria-label'>;

export const Dialog = ({
  isOpen,
  title,
  onDismiss,
  children,
  className,
  compact,
  fitContent,
  ...props
}: DialogProps) => {
  const localize = useLocalize();

  return (
    <DialogOverlay
      className={cx('z-40', fitContent && 'text-center')}
      isOpen={isOpen}
      onDismiss={onDismiss}
    >
      <DialogContent
        aria-label={title}
        className={cx(
          'relative border-t-4 border-blue-500',
          fitContent ? 'w-auto inline-block text-left' : 'w-10/12 sm:w-8/12',
          compact ? 'p-0 mt-0' : 'px-4 sm:px-8',
          className
        )}
        {...props}
      >
        <h2 className={cx('text-3xl xs:text-4xl', compact ? 'p-4' : 'pb-6')}>
          {title}
        </h2>
        <button
          onClick={onDismiss}
          type="button"
          className="absolute absolute-top-right inline-flex justify-center items-center rounded-full focus:outline-none focus:shadow-outline-blue"
        >
          <CloseIcon width={48} className="fill-current" />
          <span className="sr-only">{localize('Close')}</span>
        </button>
        {children}
      </DialogContent>
    </DialogOverlay>
  );
};
